/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Xml_Feed_ActivateInputs */

const cs_xml_feed_activate = /** @type {(inputs: Xml_Feed_ActivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obnovit feed`)
};

const en_xml_feed_activate = /** @type {(inputs: Xml_Feed_ActivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resume feed`)
};

/**
* | output |
* | --- |
* | "Resume feed" |
*
* @param {Xml_Feed_ActivateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const xml_feed_activate = /** @type {((inputs?: Xml_Feed_ActivateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Xml_Feed_ActivateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_xml_feed_activate(inputs)
	return cs_xml_feed_activate(inputs)
});